import styled from 'styled-components';
import { changeRgbLuminance } from "../../utils/changeRgbLuminance";
export const Container = styled.div`
  position: fixed;

  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);

  display: ${_ref => {
  let {
    open
  } = _ref;
  return open ? 'flex' : 'none';
}};
  align-items: center;
  justify-content: center;

  transition: all 0.3s ease-in-out;
  /* pointer-events: none;
  
    pointer-events: visible;  */
`;
export const Content = styled.div`
  width: 100%;
  max-width: ${_ref2 => {
  let {
    maxWidth
  } = _ref2;
  return maxWidth;
}}px;
  min-width: 296px;

  display: ${_ref3 => {
  let {
    open
  } = _ref3;
  return open ? 'flex' : 'none';
}};
  flex-direction: column;

  @keyframes showModal {
    from {
      opacity: 0;
      transform: translate3d(0, -200px, 0);
    }
    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  transition: all ease-in-out 0.3s;

  margin: 0 32px;

  animation: ${_ref4 => {
  let {
    open
  } = _ref4;
  return open ? 'showModal 0.3s' : 'none';
}};

  background: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colors.secondaryD1;
}};
  border-radius: 10px;
`;
export const Header = styled.div`
  height: 80px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  max-width: 100%;
  border-bottom: 1px solid ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.colors.secondaryL3;
}};
`;
export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 4px;
  flex-wrap: wrap;
  max-width: ${_ref7 => {
  let {
    screenWidth
  } = _ref7;
  return screenWidth >= 564 ? 'calc(100% - 32px)' : 'calc(100% - 16px)';
}};
`;
export const Title = styled.h3`
  ${_ref8 => {
  let {
    theme,
    screenWidth
  } = _ref8;
  return screenWidth >= 564 ? theme.fonts.titleMD : theme.fonts.titleSM;
}};
  color: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme.colors.neutralL5;
}};
  user-select: none;
  width: fit-content;
  margin: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const Description = styled.span`
  ${_ref10 => {
  let {
    theme,
    screenWidth
  } = _ref10;
  return screenWidth >= 564 ? theme.fonts.infoMD : theme.fonts.infoSM;
}};
  color: ${_ref11 => {
  let {
    theme
  } = _ref11;
  return theme.colors.neutralL5;
}};
  user-select: none;
  margin-top: 2px;
  width: fit-content;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const ContainerButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
`;
export const CloseButton = styled.button`
  height: 32px;
  width: 32px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 0;
  border-radius: 50%;
  background-color: transparent;
  outline: none;

  background-color: ${_ref12 => {
  let {
    theme
  } = _ref12;
  return theme.colors.secondaryL1;
}};

  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    background-color: ${_ref13 => {
  let {
    theme
  } = _ref13;
  return changeRgbLuminance(theme.colors.secondaryL1, 2.5);
}};
  }

  &:not(:disabled):active {
    background-color: ${_ref14 => {
  let {
    theme
  } = _ref14;
  return changeRgbLuminance(theme.colors.secondaryL1, 5);
}};
  }
`;
export const Body = styled.div`
  color: ${_ref15 => {
  let {
    theme
  } = _ref15;
  return theme.colors.neutralL5;
}};
  background: ${_ref16 => {
  let {
    theme
  } = _ref16;
  return theme.colors.secondaryD1;
}};
  user-select: none;

  padding: 10px 12px;

  overflow-y: auto;
  max-height: 166px;

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${_ref17 => {
  let {
    theme
  } = _ref17;
  return theme?.colors?.secondaryL2;
}};
    border-radius: 10px;
  }
`;
export const Wrapper = styled.div`
  padding: 16px 12px;
`;
export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 16px;

  flex: 1;

  gap: 16px;

  width: 100%;
  max-width: ${_ref18 => {
  let {
    maxWidth
  } = _ref18;
  return maxWidth;
}}px;

  flex-wrap: wrap;

  button {
    flex: 1;
  }
`;